import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import AuthService from '../services/AuthService';

const UserContext = createContext();

export function UserProvider({ children }) {
  const authService = useMemo(() => new AuthService(), []);
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    const init = async () => {
      await authService.bootstrap();
      if (!active) return;
      setUser(authService.getSession());
      setReady(true);
    };
    init();
    return () => {
      active = false;
    };
  }, [authService]);

  const signIn = async (email, password) => {
    const result = await authService.signIn(email, password);
    if (result.session) {
      setUser(result.session);
    }
    return result;
  };

  const signOut = () => {
    authService.signOut();
    setUser(null);
  };

  const updateSession = (partial) => {
    const session = authService.updateSession(partial);
    setUser(session);
  };

  const setSession = (next) => {
    const value = typeof next === 'function' ? next(authService.getSession() || {}) : next;
    const session = authService.updateSession(value || {});
    setUser(session);
  };

  return (
    <UserContext.Provider value={{ user, setUser: setSession, signIn, signOut, updateSession, ready }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  return context || { user: null, signIn: async () => ({}), signOut: () => {}, updateSession: () => {}, ready: true };
}
